<template>
  <v-container
    class="pa-0 max-width-md"
  >
    <v-card
      flat
      tile
      class="pa-3 pt-2"
    >
      <v-skeleton-loader
        v-if="!course"
        type="list-item-avatar, list-item-three-line, list-item-avatar, article, card-heading"
      />

      <template v-if="course">
        <v-toolbar
          flat
        >
          <v-btn
            icon
            to="/training/list"
          >
            <v-icon>{{ mdiArrowLeft }}</v-icon>
          </v-btn>
          <v-toolbar-title>
            {{ $chPtObjData('chinName', course.pcDetail) }}
          </v-toolbar-title>
          <v-spacer />
          <!--v-if="course.pcDetail.outlineDmsId" -->
          <s-class-pdf
            v-if="false"
            show-desc
            :url="course.pcDetail.outlineDmsId"
          />
        </v-toolbar>

        <!-- <s-error-dialog
          :message="errorMessage"
          :show.sync="showError"
        /> -->

        <p>
          {{ $t('TrainingClient.applicationForm.remark1') }}
        </p>

        {{ $t('TrainingClient.Course') }}: {{ $chPtObjData('chinName', course.pcDetail) }}
        <div class="grey--text text--darken-1">
          <!-- {{ $t('TrainingClient.Course.EnrollmentDate') }}: {{ momentWithHyphen(course.pcDetail.startDate).format('YYYY-MM-DD') }} <br> -->
          {{ $t('TrainingClient.Course.Expire') }} {{ momentWithHyphen(course.pcDetail.endEnrollmentDate).format('YYYY-MM-DD') }}
        </div>

        <br>

        <div class="section-header">
          <span>1. {{ $t('TrainingClient.Identity') }}</span>
          <v-spacer />
          <v-btn
            text
            icon
            @click="isEditPersonalData = !isEditPersonalData"
          >
            <v-icon>
              {{ mdiPencil }}
            </v-icon>
          </v-btn>
        </div>

        <div
          v-if="!isEditPersonalData"
          class="mt-2"
        >
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              {{ $t('TrainingClient.Identity.name') }}: {{ form.chinName }} {{ form.portName }}<br>
              {{ $t('PublicServant.Me.PersonalInfo.BirthDate') }}: {{ momentWithHyphen(form.birthday).format('YYYY-MM-DD') }}<br>
              {{ $t('HR.Gender') }}: {{ $t('Text.'+form.sex) }}<br>
              {{ $t('PublicServant.Personal.Credentials.DocNum') }}: {{ maskDocNum }} <br>
              {{ $t('PublicServant.Personal.Credentials.IdentityDocType') }}: {{ $chPtObjData('identityDocTypeChinDesc', staff) }}
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              {{ $t('Training.Apply.MobileWithRemark') }}: {{ form.mobile }}
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              {{ $t('TrainingClient.Contact.CompanyTel') }}: {{ form.companyTel }}
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              {{ $t('TrainingClient.Contact.Email') }}: {{ form.email }}
            </v-col>
          </v-row>
        </div>

        <v-form
          ref="trainingAppForm"
        >
          <div v-if="isEditPersonalData">
            <v-row>
              <v-col
                class="mt-2"
                cols="12"
              >
                {{ $t('TrainingClient.Identity.name') }}: {{ form.chinName }} {{ form.portName }}
              </v-col>
              <v-col
                cols="12"
                md="3"
              >
                <v-text-field
                  v-model="mobile"
                  :rules="rules.mobile"
                  :label="$t('Training.Apply.MobileWithRemark')"
                  :hint="$t('Training.Apply.OnlyMacauTel')"
                />
              </v-col>
              <v-col
                cols="12"
                md="3"
              >
                <v-text-field
                  v-model="companyTel"
                  :rules="rules.companyTel"
                  :label="$t('TrainingClient.Contact.CompanyTel')"
                />
              </v-col>
              <v-col
                cols="12"
                md="3"
              >
                <v-text-field
                  v-model="fax"
                  :label="$t('TrainingClient.Contact.Fax')"
                  value=""
                />
              </v-col>
              <v-col
                cols="12"
                md="3"
              >
                <v-text-field
                  v-model="email"
                  :label="$t('TrainingClient.Contact.Email')"
                  required
                />
              </v-col>
            </v-row>
          </div>

          <br>

          <div class="section-header">
            <span>2. {{ $t('TrainingClient.CurrentCareer') }}</span>
            <v-spacer />
            <v-btn
              text
              icon
              @click="isEditCarrer = !isEditCarrer"
            >
              <v-icon>
                {{ mdiPencil }}
              </v-icon>
            </v-btn>
          </div>

          <div
            v-if="!isEditCarrer"
            class="mt-2"
          >
            <v-row dense>
              <v-col
                cols="12"
                md="6"
              >
                {{ $t('TrainingClient.Entity') }}: {{ $chPtObjData('chinEntityName', form) }}
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                {{ $t('PublicServant.Entity.SubEntity') }}: {{ $chPtObjData('chinSubunitEntityName', form) }}
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                {{ $t('PublicServant.Vinculum') }}: {{ $chPtObjData('chinVinculumTypeName', form) }}
              </v-col>
              <v-col
                v-if="careerType === 2"
                cols="12"
                md="6"
              >
                {{ $t('TrainingClient.CareerOrOfficial.Official') }}: {{ $chPtObjData('officialTypeChinDesc', staff) }}
              </v-col>
              <v-col
                v-if="careerType !== 2"
                cols="12"
                md="6"
              >
                {{ $t('TrainingClient.Career') }}: {{ $chPtObjData('categoryScaleChinDescForDisplay', staff) }}
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                {{ $t('TrainingClient.EnterGovDate') }}: {{ momentWithHyphen(form.enterGovDate).format('YYYY-MM-DD') }}
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                {{ $t('TrainingClient.EnterCareerDate') }}: {{ momentWithHyphen(form.enterCareerDate).format('YYYY-MM-DD') }}
              </v-col>
            </v-row>
          </div>

          <div v-if="isEditCarrer">
            <v-row>
              <v-col cols="12">
                {{ $t('TrainingClient.Entity') }}: {{ $chPtObjData('chinEntityName', form) }}
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-autocomplete
                  v-model="subunitEntityId"
                  :items="subunits"
                  :item-text="$chPtField('chinName')"
                  item-value="id"
                  :label="$t('PublicServant.Entity.SubEntity')"
                  :rules="rules.requiredField"
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-autocomplete
                  v-model="vinculumTypeId"
                  :items="vinculumTypes"
                  :item-text="$chPtField('chinDesc')"
                  item-value="id"
                  :label="$t('PublicServant.Vinculum')"
                  :rules="rules.requiredField"
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-select
                  v-model="careerType"
                  :items="generalOrSupervisor"
                  :item-text="$chPtField('chinName')"
                  item-value="id"
                  :label="$t('Training.Apply.CareerOrOfficial')"
                  :rules="rules.requiredField"
                />
              </v-col>
            </v-row>

            <v-row v-if="careerType === 2">
              <v-col xs4>
                <v-autocomplete
                  v-model="officialTypeId"
                  :items="officialTypes"
                  :item-text="$chPtField('chinDisplayDesc')"
                  item-value="id"
                  :label="$t('TrainingClient.CareerOrOfficial.Official')"
                  :rules="rules.requiredField"
                />
              </v-col>
            </v-row>

            <v-row v-if="careerType !== 2">
              <v-col
                cols="12"
                md="4"
              >
                <v-autocomplete
                  v-model="careerId"
                  :items="careers"
                  :item-text="$chPtField('chinDesc')"
                  item-value="id"
                  :label="$t('TrainingClient.Career')"
                  :rules="rules.requiredField"
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-autocomplete
                  v-model="categoryId"
                  :items="categories"
                  :item-text="$chPtField('chinDisplayDesc')"
                  item-value="id"
                  :label="$t('PublicServant.Career.Category.StaffCategory')"
                  :rules="rules.requiredField"
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-select
                  v-model="categoryScaleId"
                  :items="categoryScales"
                  :item-text="$chPtField('chinDisplayDesc')"
                  item-value="id"
                  :label="$t('PublicServant.Career.Category.StaffCategoryScale')"
                  :rules="rules.requiredField"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="4"
              >
                <s-date-picker
                  v-model="enterGovDate"
                  :label="$t('TrainingClient.EnterGovDate')"
                  :rules="rules.requiredField"
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <s-date-picker
                  v-model="enterCareerDate"
                  :label="$t('TrainingClient.EnterCareerDate')"
                  :hint="$t('TrainingClient.EnterCareerDate')"
                  :rules="rules.requiredField"
                />
              </v-col>
            </v-row>
          </div>

          <v-row>
            <v-col cols="12">
              <v-textarea
                v-model="jobDescription"
                :label="$t('TrainingClient.JobDescription')"
                :hint="$t('TrainingClient.JobDescription')"
                rows="2"
                :rules="rules.jobDescription"
              />
            </v-col>
          </v-row>

          <br>

          <div class="section-header">
            <span>3. {{ $t('Training.ApplyReason') }}</span>
          </div>

          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <v-select
                v-model="applyReasonCode"
                :items="applyReasons"
                :item-text="$chPtField('chinDesc')"
                item-value="code"
                :label="$t('TrainingClient.Reason')"
                :rules="rules.requiredField"
              />
            </v-col>
          </v-row>

          <br>

          <div class="section-header">
            <span>4. {{ $t('Training.SubmitTarget') }}</span>
          </div>

          <v-row dense>
            <v-col cols="12">
              <v-radio-group
                v-model="isDirectToCoordinator"
                row
              >
                <v-radio
                  :label="$t('TrainingClient.Superior')"
                  value="0"
                />
                <v-radio
                  :label="$t('Training.TrainingCoordinator')"
                  value="1"
                />
              </v-radio-group>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <s-search-staff
                v-if="isDirectToCoordinator!=='1'"
                show-support-staff
                show-group
                :select.sync="firstApproverEuid"
                :staff.sync="toStaffObj"
                :label="$t('Training.SubmitTarget')"
              />
            </v-col>
          </v-row>

          <br>

          <div
            class="section-header"
            @click="showNotice = !showNotice"
          >
            <span>{{ $t('PublicServant.Reminds') }} / {{ $t('Training.PersonalDataStatement') }}</span>
            <v-spacer />
            <v-btn
              text
              icon
            >
              <v-icon v-if="showNotice">
                {{ mdiChevronUp }}
              </v-icon>
              <v-icon v-if="!showNotice">
                {{ mdiChevronDown }}
              </v-icon>
            </v-btn>
          </div>

          <v-row class="mt-2">
            <v-col
              v-if="showNotice"
              cols="12"
            >
              {{ $t('PublicServant.Reminds') }}<br>
              <span v-html="$t('Training.Notice.Content')" />
              <p />
              {{ $t('Training.PersonalDataStatement') }} <br>
              <span v-html="$t('Training.PersonalDataStatement.Content')" />
            </v-col>
          </v-row>

          <v-checkbox
            v-model="isAgree"
            :label="$t('TrainingClient.OnlineApply.DeclarationByApplicant.Remark1')"
          />

          <div>
            <v-btn
              :disabled="!isAgree"
              :loading="loading"
              color="primary"
              class="ml-0"
              @click="submit"
            >
              {{ $t('Text.Submit') }}
            </v-btn>
          </div>
        </v-form>
      </template>
    </v-card>

    <s-yes-no-dialog
      v-model="isUseBdrhDialog"
      :message="$t('Training.Question.BDRHDefault')"
      :is-confirm.sync="isConfirmUseBdrh"
    />
  </v-container>
</template>

<script>

import { momentWithHyphen } from '@/utils/datetimeUtil'
import SDatePicker from '../../components/SDatePicker'
import SYesNoDialog from '../../components/SYesNoDialog'
// import SErrorDialog from '../../components/SErrorDialog'
import { mapState } from 'vuex'
import SClassPdf from '../../components/SClassPdf'
import SSearchStaff from '../../components/SSearchStaff'
import courseApi from '../../api/training/course'
import { formatDateTime } from '../../utils/datetimeUtil'
import { breakSubErrors } from '../../utils/messageUtil'
import { isFieldBlank, maskEnd } from '../../utils/stringUtil'
import codeTable from '../../store/modules/hr/codeTable'
import courses from '../../store/modules/training/courses'
import { mapCourseAppFormFields, courseAppForm } from '../../store/modules/training/courseAppForm'
import { trainingTaskList } from '../../store/modules/training/taskList'
import store from '../../store'
import { globalModule, staffModule, coursesModule, codeTableModule, courseAppFormModule, trainingTLModule } from '../../store/moduleName'
import VuetifyJetValidator from 'vuetify-jet-validator'
import { mdiArrowLeft, mdiPencil, mdiChevronUp, mdiChevronDown } from '@mdi/js'

// We're dynamically registering the
// `courseAppForm` store module. This has
// the benefit of only loading this
// module, if it's actually needed.
// Before registering the module, we're
// checking if it's already registered
// which can happen in combination with
// webpacks hot reloading.
if (!store.state[codeTableModule]) store.registerModule(codeTableModule, codeTable)
if (!store.state[courseAppFormModule]) store.registerModule(courseAppFormModule, courseAppForm)
if (!store.state[trainingTLModule]) store.registerModule(trainingTLModule, trainingTaskList)
if (!store.state[coursesModule]) store.registerModule(coursesModule, courses)

export default {
  components: {
    SDatePicker,
    SYesNoDialog,
    SClassPdf,
    SSearchStaff
    // SErrorDialog
  },
  props: {
    courseId: {
      type: String,
      required: true
    }
  },
  data: function () {
    const validator = new VuetifyJetValidator()
    return {
      mdiChevronDown: mdiChevronDown,
      mdiChevronUp: mdiChevronUp,
      mdiPencil: mdiPencil,
      mdiArrowLeft: mdiArrowLeft,
      isDirectToCoordinator: '0',
      // errorMessage: null,
      // showError: false,
      isConfirmUseBdrh: null,
      isUseBdrhDialog: true,
      // useOrClear: true,
      enterGovDateMenu: false,
      appraiser: '',
      isEditPersonalData: false,
      isEditCarrer: false,
      showNotice: false,
      isAgree: false,
      loading: false,
      toStaffObj: null,
      generalOrSupervisor: [{
        id: 1,
        chinName: this.$t('TrainingClient.Career', 'zh'),
        portName: this.$t('TrainingClient.Career', 'pt')
      },
      { id: 2,
        chinName: this.$t('TrainingClient.CareerOrOfficial.Official', 'zh'),
        portName: this.$t('TrainingClient.CareerOrOfficial.Official', 'pt')
      }
      ],
      rules: {
        requiredField: [
          validator.rules.required(this.$t('TrainingClient.RequiredField'))
        ],
        mobile: [
          // validator.rules.required(this.$t('TrainingClient.RequiredField')),
          validator.rules.maxLength(8, this.$t('Training.Error.MaxChar', [this.$t('TrainingClient.Contact.Mobile'), 8]))
        ],
        companyTel: [
          // validator.rules.required(this.$t('TrainingClient.RequiredField')),
          validator.rules.maxLength(8, this.$t('Training.Error.MaxChar', [this.$t('TrainingClient.Contact.CompanyTel'), 8]))
        ],
        email: [
          // validator.rules.required(this.$t('TrainingClient.RequiredField')),
          // validator.rules.email(this.$t('Training.Error.FormatInvalid', [this.$t('TrainingClient.Contact.Email')]))
        ],
        jobDescription: [
          validator.rules.required(this.$t('TrainingClient.RequiredField')),
          validator.rules.maxLength(300, this.$t('Training.Error.MaxChar', [this.$t('TrainingClient.JobDescription'), 300]))
        ]
        // applyReasonCode: [
        //   validator.rules.required(this.$t('TrainingClient.RequiredField'))
        // ],
        // firstApproverStaffCode: [
        //   validator.rules.required(this.$t('TrainingClient.RequiredField'))
        // ]
      }
    }
  },
  computed: {
    ...mapCourseAppFormFields(
      [
        'info.applyReasonCode',
        'info.firstApproverEuid',
        'info.birthday',
        'info.careerType',
        'info.categoryScaleId',
        'info.chinName',
        'info.companyTel',
        'info.euid',
        'info.email',
        'info.enterCareerDate',
        'info.enterGovDate',
        'info.entityId',
        'info.fax',
        'info.idCardNo',
        'info.jobDescription',
        'info.mobile',
        'info.officialTypeId',
        'info.portName',
        'info.proposalClassId',
        'info.sex',
        'info.staffCode',
        'info.status',
        'info.subunitEntityId',
        'info.vinculumTypeId']
    ),
    careerId: {
      get () {
        return this.$store.state[courseAppFormModule].info.careerId
      },
      set (value) {
        this.$store.commit(courseAppFormModule + '/setCareerId', value)
        this.$store.dispatch(codeTableModule + '/getCategories', value)
        // setTimeout(() => {
        //   this.$store.dispatch(courseAppFormModule + '/fillChinPortNames')
        // }, 500)
      }
    },
    categoryId: {
      get () {
        return this.$store.state[courseAppFormModule].info.categoryId
      },
      set (value) {
        this.$store.commit(courseAppFormModule + '/setCategoryId', value)
        this.$store.dispatch(codeTableModule + '/getCategoryScales', value)
        // setTimeout(() => {
        //   this.$store.dispatch(courseAppFormModule + '/fillChinPortNames')
        // }, 500)
      }
    },
    // maskDocNum: {
    //   get () {
    //     return maskEnd(this.staff.docNum, 5, '*')
    //   }
    // },

    ...mapState({
      course: state => state[coursesModule].course,
      staff: state => state[staffModule].info,
      maskDocNum: state => maskEnd(state[staffModule].info.docNum, 5, '*'),
      form: state => state[courseAppFormModule].info,
      applyReasons: state => state[trainingTLModule].appraiserReasons
    }),

    ...mapState(codeTableModule, {
      careers: state => state.careers,
      categories: state => state.categories,
      categoryScales: state => state.categoryScales,
      subunits: state => state.subunits,
      vinculumTypes: state => state.vinculumTypes,
      officialTypes: state => state.officialTypes
    })
  },
  watch: {
    isConfirmUseBdrh: function (val) {
      if (!val) {
        this.$store.dispatch(courseAppFormModule + '/clearForm')
        this.isEditPersonalData = true
        this.isEditCarrer = true
      }
    },

    isDirectToCoordinator (value) {
      if (value === '1') {
        this.$store.commit(courseAppFormModule + '/setFirstApproverEuid', null)
        this.$store.commit(courseAppFormModule + '/setFirstApproverGroupId', null)
        this.$store.commit(courseAppFormModule + '/setIsDirectToCoordinator', true)
      } else if (value === '0') {
        this.$store.commit(courseAppFormModule + '/setIsDirectToCoordinator', false)
        this.$store.commit(courseAppFormModule + '/setFirstApproverEuid', this.$store.state[staffModule].info.defaultNextEuid)
      }
    }
  },
  async created () {
    if (this.courseId) { // clear course data in order to show loading
      this.$store.commit(coursesModule + '/setCourse', null)
    }
    if (!this.staff) {
      await this.$store.dispatch(staffModule + '/getStaff')
    }
    if (!this.$store.state[coursesModule].all.length || this.$store.state[coursesModule].all.length < 1) {
      await this.$store.dispatch(coursesModule + '/getAllCurrentCourse')
    }
    if (this.staff.careerId) {
      await this.$store.dispatch(codeTableModule + '/getCategories', this.staff.careerId)
    }
    if (this.staff.categoryId) {
      await this.$store.dispatch(codeTableModule + '/getCategoryScales', this.staff.categoryId)
    }
    await this.$store.dispatch(codeTableModule + '/getCareers')
    if (this.staff.entityId) {
      await this.$store.dispatch(codeTableModule + '/getOfficialTypes', this.staff.entityId)
      await this.$store.dispatch(codeTableModule + '/getSubunits', this.staff.entityId)
    }
    await this.$store.dispatch(codeTableModule + '/getVinculumTypes')
    this.$store.dispatch(trainingTLModule + '/getAppraiserReasons')
    if (this.courseId) {
      this.$store.dispatch(coursesModule + '/getCourse', ~~this.courseId) // '~~' can change String to Number
    }
    this.$store.dispatch(courseAppFormModule + '/initForm')
    // setTimeout(() => {
    this.$store.dispatch(courseAppFormModule + '/fillChinPortNames')
    // }, 500)
  },
  methods: {
    submit: function () {
      this.loading = true
      this.proposalClassId = ~~this.courseId

      if (this.form.firstApproverEuid && this.toStaffObj.definedGroupId) {
        this.$store.commit(courseAppFormModule + '/setFirstApproverEuid', null)
        this.$store.commit(courseAppFormModule + '/setFirstApproverGroupId', this.toStaffObj.definedGroupId)
      }
      var tempForm = JSON.parse(JSON.stringify(this.form))
      tempForm.enterCareerDate = formatDateTime(tempForm.enterCareerDate)
      tempForm.enterGovDate = formatDateTime(tempForm.enterGovDate)
      var finalForm = JSON.stringify(tempForm)
      let errorMessage = [{ chinMessage: '', portMessage: '' }]

      if (isFieldBlank(this.form.mobile) && isFieldBlank(this.form.companyTel)) {
        errorMessage[0].chinMessage = this.$t('TrainingClient.Error.MobileCompanyTelEmpty', 'zh')
        errorMessage[0].portMessage = this.$t('TrainingClient.Error.MobileCompanyTelEmpty', 'pt')
      }
      if (isFieldBlank(this.form.enterCareerDate) ||
      isFieldBlank(this.form.enterGovDate) || isFieldBlank(this.form.applyReasonCode)) {
        Object.assign(errorMessage, { 'chinMessage': this.$t('TrainingClient.RequiredField'), 'portMessage': this.$t('TrainingClient.RequiredField') })
      }
      if (errorMessage[0].chinMessage.length > 0) {
        this.$store.dispatch(globalModule + '/setErrorMessage', this.$chPtObjData('chinMessage', breakSubErrors(errorMessage)))
        this.loading = false
        return false
      }

      if (!this.$refs.trainingAppForm.validate()) {
        this.loading = false
        return false
      }

      courseApi.submitForm(finalForm, cb => {
        if (cb.status === 201 || cb.status === 200) {
          this.$store.dispatch(globalModule + '/setSnackbarMsg', this.$t('Training.Msg.SubmitSuccess'))
          this.$router.push({ name: 'trainingList' })
        }

        this.loading = false
      })
    },
    momentWithHyphen: momentWithHyphen
  }
}
</script>
